export const columnListG = [
  { col: "货主名称", prop: "customerName", mergeRow: true, width: 180, fixed: false },
  { col: "操作人", prop: "operateName", mergeRow: false, width: 120, fixed: false },
  { col: "来源", prop: "systemCode", mergeRow: false, width: 120, fixed: false },
  { col: "是否取消", prop: "deleteStatusStr", mergeRow: false, width: 90, fixed: false },
  { col: "创建时间", prop: "operateTm", mergeRow: false, width: 140, fixed: false }, 
  { col: "外部订单号", prop: "outerOrderId", mergeRow: false, width: 140, fixed: false },
  { col: "客户运单号", prop: "customerWaybillId", mergeRow: false, width: 150, fixed: false },
  { col: "提货单号", prop: "goodsOrderId", mergeRow: false, width: 150, fixed: false },
  { col: "提货单版本号", prop: "version", mergeRow: false, width: 150, fixed: false },
  { col: "提货点名称", prop: "goodsAddrName", mergeRow: false, width: 150, fixed: false },
  { col: "发货方名称", prop: "goodsName", mergeRow: false, width: null, fixed: false },
  { col: "预计提货日期", prop: "planData", mergeRow: false, width: 140, fixed: false },
  { col: "预计提货时间", prop: "planTimeLimit", mergeRow: false, width: 140, fixed: false },
  { col: "总重量（KG）", prop: "totalWeight", mergeRow: false, width: null, fixed: false },
  { col: "总体积（m³）", prop: "totalCapacity", mergeRow: false, width: null, fixed: false },
  { col: "总数量", prop: "totalQuantity", mergeRow: false, width: null, fixed: false },
  { col: "司机需提供增值服务", prop: "driverService", mergeRow: false, width: null, fixed: false },
  { col: "司机是否需要操作APP", prop: "driverOperateType", mergeRow: false, width: null, fixed: false } //1、是，2、否
];
export const columnListS = [
  { col: "货主名称", prop: "customerName", mergeRow: true, width: 180, fixed: false },
  { col: "操作人", prop: "operateName", mergeRow: false, width: 120, fixed: false },
  { col: "来源", prop: "systemCode", mergeRow: false, width: 120, fixed: false },
  { col: "是否取消", prop: "deleteStatusStr", mergeRow: false, width: 90, fixed: false },
  { col: "创建时间", prop: "operateTm", mergeRow: false, width: 140, fixed: false }, 
  { col: "外部订单号", prop: "outerOrderId", mergeRow: false, width: 140, fixed: false },
  { col: "客户运单号", prop: "customerWaybillId", mergeRow: false, width: 150, fixed: false },
  { col: "送货单号", prop: "goodsOrderId", mergeRow: false, width: 150, fixed: false },
  { col: "送货单版本号", prop: "version", mergeRow: false, width: 150, fixed: false },
  { col: "送货点名称", prop: "goodsAddrName", mergeRow: false, width: 150, fixed: false },
  { col: "收货方名称", prop: "goodsName", mergeRow: false, width: null, fixed: false },
  { col: "预计到货日期", prop: "planData", mergeRow: false, width: 140, fixed: false },
  { col: "预计到货时间", prop: "planTimeLimit", mergeRow: false, width: 140, fixed: false },
  { col: "总重量（KG）", prop: "totalWeight", mergeRow: false, width: null, fixed: false },
  { col: "总体积（m³）", prop: "totalCapacity", mergeRow: false, width: null, fixed: false },
  { col: "总数量", prop: "totalQuantity", mergeRow: false, width: null, fixed: false },
  { col: "司机需提供增值服务", prop: "driverService", mergeRow: false, width: null, fixed: false },
  { col: "司机是否需要操作APP", prop: "driverOperateType", mergeRow: false, width: null, fixed: false } //1、是，2、否
];

export const columnList = [
  { col: "货主名称", prop: "customerName", mergeRow: true, width: 180, fixed: false },
  { col: "订单号", prop: "orderId", mergeRow: false, width: 140, fixed: false },
  { col: "操作人", prop: "operateName", mergeRow: false, width: 120, fixed: false },
  { col: "来源", prop: "systemCode", mergeRow: false, width: 120, fixed: false },
  { col: "是否取消", prop: "deleteStatusStr", mergeRow: false, width: 90, fixed: false },
  { col: "创建时间", prop: "operateTm", mergeRow: false, width: 140, fixed: false }, 
  { col: "外部订单号", prop: "outerOrderId", mergeRow: false, width: 140, fixed: false },
  { col: "客户运单号", prop: "customerWaybillId", mergeRow: false, width: 150, fixed: false },
  { col: "提送货类型", prop: "dataType", mergeRow: false, width: 90, fixed: false },
  { col: "提送货单号", prop: "goodsOrderId", mergeRow: false, width: 150, fixed: false },
  { col: "提送货单版本号", prop: "version", mergeRow: false, width: 150, fixed: false },
  { col: "提送货点名称", prop: "goodsAddrName", mergeRow: false, width: 150, fixed: false },
  { col: "发（收）货方名称", prop: "goodsName", mergeRow: false, width: null, fixed: false },
  { col: "预计提（送）货日期", prop: "planData", mergeRow: false, width: 140, fixed: false },
  { col: "预计提（送）货时间", prop: "planTimeLimit", mergeRow: false, width: 140, fixed: false },
  { col: "总重量（KG）", prop: "totalWeight", mergeRow: false, width: null, fixed: false },
  { col: "总体积（m³）", prop: "totalCapacity", mergeRow: false, width: null, fixed: false },
  { col: "总数量", prop: "totalQuantity", mergeRow: false, width: null, fixed: false },
  { col: "司机需提供增值服务", prop: "driverService", mergeRow: false, width: null, fixed: false },
  { col: "司机是否需要操作APP", prop: "driverOperateType", mergeRow: false, width: null, fixed: false } //1、是，2、否
]